import {} from "../node/index.js";
import { nodeKey } from "../node/nodeKey.js";
import {} from "./Net.js";
export function deleteNodeEntry(net, node) {
    net.nodeEntries.delete(nodeKey(node));
}
//# sourceMappingURL=deleteNodeEntry.js.map